import React, {useState, useEffect, useRef} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {Card, CardContent, Paper, Backdrop} from '@material-ui/core';

const ActionButton = ({imageUrl, activeImageUrl, disabled, childComponent, childProps}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const active = !!anchorEl;
  const buttonContainer = useRef(null);
  useEffect(
    () => {
      if (active) {
        const {left: anchorLeft, bottom: anchorBottom} = anchorEl.getBoundingClientRect();
        const popoverEl = buttonContainer.current.querySelector('.bentobox-toolbar-popover');
        const widthOfPopover = popoverEl.getBoundingClientRect().width;
        const {height: benboHeight, width: benboWidth} = anchorEl.closest('.bentobox-wrapper').getBoundingClientRect();
        popoverEl.style.left = `${benboWidth - anchorLeft - widthOfPopover}px`;
        popoverEl.style.maxHeight = `${benboHeight - anchorBottom}px`;
      }
    },
    [active],
  );
  return (
    <div className="action-button" ref={buttonContainer}>
      <img
        className={classNames({
          action: true,
          disabled,
          active,
        })}
        src={active ? activeImageUrl : imageUrl}
        onClick={disabled ? undefined : handleClick}
      />
      {active && (
        <>
          <Backdrop className="bentobox-popover-backdrop" open={active} onClick={handleClose} />
          <Paper
            {...{
              className: 'bentobox-toolbar-popover',
              square: true,
            }}
          >
            <Card square tabIndex="-1">
              <CardContent>{React.createElement(childComponent, childProps)}</CardContent>
            </Card>
          </Paper>
        </>
      )}
    </div>
  );
};

ActionButton.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  activeImageUrl: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  childComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.string]).isRequired,
  childProps: PropTypes.object.isRequired,
};

ActionButton.defaultProps = {
  disabled: false,
  childProps: {},
};

export default ActionButton;
